import { trackCustom, getUtmParams } from './pixel';

type EventProps = Record<string, unknown>;

function captureToPostHog(event: string, props?: EventProps) {
  if (typeof window === 'undefined' || !window.posthog) return;
  window.posthog.capture(event, props);
}

export function trackEvent(event: string, props?: EventProps) {
  const merged = { ...getUtmParams(), ...(props ?? {}) };
  trackCustom(event, merged);
  captureToPostHog(event, merged);
}

export function trackPostHog(event: string, props?: EventProps) {
  captureToPostHog(event, { ...getUtmParams(), ...(props ?? {}) });
}
